import axios from "axios";
import config from "app/api/axiosConfig";
import { IAnswerRequest } from "app/api/types";

export default (token: string, data: IAnswerRequest) =>
  axios.put(
    `${process.env.REACT_APP_API_HOST}/admin/messages`,
    data,
    config(token)
  );
